<button class="switch" [class.checked]="isChecked" [class.disabled]="isDisabled" (click)="onToggle()">
    <div class="switch-button" [class.checked]="isChecked" [class.disabled]="isDisabled"></div>
</button>